export const SET_CART_DRAWER_OPEN = 'GCG/SET_CART_DRAWER_OPEN';
export const setCartDrawerOpen = (isOpen) => ({
    type: SET_CART_DRAWER_OPEN,
    isOpen
});
